import { ReactNode } from 'react';

type AlertType = 'info' | 'success' | 'warning' | 'error';

interface AlertProps {
  type?: AlertType;
  title?: string;
  children: ReactNode;
  className?: string;
}

const styles: Record<AlertType, { wrap: string; icon: string }> = {
  info:    { wrap: 'bg-broker-bg dark:bg-blue-950 border-broker-border dark:border-blue-800 text-blue-900 dark:text-blue-100',  icon: 'ℹ️' },
  success: { wrap: 'bg-success-bg dark:bg-green-950 border-success-border dark:border-green-800 text-green-900 dark:text-green-100', icon: '✅' },
  warning: { wrap: 'bg-warning-bg dark:bg-yellow-950 border-warning-border dark:border-yellow-800 text-yellow-900 dark:text-yellow-100', icon: '⚠️' },
  error:   { wrap: 'bg-danger-bg dark:bg-red-950 border-danger-border dark:border-red-800 text-red-900 dark:text-red-100',   icon: '❌' },
};

export function Alert({ type = 'info', title, children, className = '' }: AlertProps) {
  const { wrap, icon } = styles[type];
  return (
    <div className={`flex items-start gap-3 border rounded-xl p-4 ${wrap} ${className}`}>
      <span className="text-lg flex-shrink-0 leading-tight">{icon}</span>
      <div className="text-sm leading-relaxed">
        {title && <p className="font-semibold mb-0.5">{title}</p>}
        <p className="opacity-90">{children}</p>
      </div>
    </div>
  );
}
